export const namespaced = true;

export const state = {
  name: "",
};
export const mutations = {
  setName: (state, payload) => {
    state.name = payload;
  },
};
export const getters = {
  name: (state) => state.name,
};
export const actions = {};
